import { useEffect } from "react";
import * as CookieConsent from "vanilla-cookieconsent";
import "vanilla-cookieconsent/dist/cookieconsent.css";

import { useMaterialUIController } from "context";

import "./cookieConsent.css";

const cookieConsentConfig = {
  guiOptions: {
    consentModal: {
      layout: "box inline",
      position: "bottom right",
      equalWeightButtons: true,
    },
    preferencesModal: {
      layout: "box",
      equalWeightButtons: true,
    },
  },
  cookie: {
    name: "p360_cookie_consent",
  },
  categories: {
    necessary: {
      enabled: true,
      readOnly: true,
    },
    analytics: {},
    marketing: {
      services: {
        adsense: {
          label: "Google AdSense",
        },
      },
    },
  },
  language: {
    default: "pt",
    translations: {
      pt: {
        consentModal: {
          title: "Preferências de cookies",
          description:
            "Usamos cookies necessários para o Patrimônio360 funcionar e cookies opcionais para medir uso e exibir anúncios.",
          acceptAllBtn: "Aceitar todos",
          acceptNecessaryBtn: "Rejeitar opcionais",
          showPreferencesBtn: "Gerenciar preferências",
        },
        preferencesModal: {
          title: "Preferências de cookies",
          closeIconLabel: "Fechar",
          acceptAllBtn: "Aceitar todos",
          acceptNecessaryBtn: "Rejeitar opcionais",
          savePreferencesBtn: "Salvar preferências",
          sections: [
            {
              title: "Como usamos cookies",
              description:
                "Você pode escolher quais cookies opcionais autoriza. Os cookies necessários permanecem ativos para manter o app funcionando.",
            },
            {
              title: "Necessários",
              description:
                "Mantêm recursos essenciais do site e do app funcionando corretamente.",
              linkedCategory: "necessary",
            },
            {
              title: "Analytics",
              description:
                "Ajudam a entender o uso do produto para melhorar fluxos e desempenho.",
              linkedCategory: "analytics",
            },
            {
              title: "Marketing",
              description:
                "Permitem carregar serviços de publicidade e medir a entrega de anúncios.",
              linkedCategory: "marketing",
            },
          ],
        },
      },
    },
  },
};

export const showCookiePreferences = () => {
  CookieConsent.showPreferences();
};

function CookieConsentManager() {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  useEffect(() => {
    CookieConsent.run(cookieConsentConfig);
  }, []);

  useEffect(() => {
    document.documentElement.classList.toggle("cc--darkmode", darkMode);

    return () => {
      document.documentElement.classList.remove("cc--darkmode");
    };
  }, [darkMode]);

  return null;
}

export default CookieConsentManager;
